export default {
  'hs program training': 'Program Training',
  'hs b&c collection 1': 'Pathway 1',
  'hs b&c collection 2': 'Pathway 1',
  'hs b&c collection 3': 'Pathway 1',
  'hs c&c collection 1': 'Pathway 2',
  'hs c&c collection 2': 'Pathway 2',
  'hs c&c collection 3': 'Pathway 2',
  'hs a&o collection 1': 'Pathway 3',
  'hs a&o collection 2': 'Pathway 3',
  'hs a&o collection 3': 'Pathway 3',
  'hs w&c collection 1': 'Pathway 4',
  'hs w&c collection 2': 'Pathway 4',
  'hs w&c collection 3': 'Pathway 4',
  titlesByPracticeType: {
    educator: {
      pathway1: {
        collection_1: '1. Co-Creating Classroom Agreements',
        collection_2: '2. Memory Tricks',
        collection_3: '3. Communicating Belonging',
      },
      pathway2: {
        collection_1: '1. Reaching Mastery',
        collection_2: '2. Making Success Attainable',
        collection_3: '3. Authentic Feedback',
      },
      pathway3: {
        collection_1: '1. Choice Boards',
        collection_2: '2. Academic Discussions',
        collection_3: '3. Implementing Student Feedback',
      },
      pathway4: {
        collection_1: '1. Mind Breaks',
        collection_2: '2. Gratitude Practice',
        collection_3: '3. Positive Self-Talk',
      },
    },
    sitewide: {
      pathway1: {
        collection_1: '1. Greeting Students Across Campus',
        collection_2: '2. Schoolwide Agreements',
        collection_3: '3. Two Minutes a Day',
      },
      pathway2: {
        collection_1: '1. High Expectations',
        collection_2: '2. Staff Talent Showcase',
        collection_3: '3. Yet! Campaign',
      },
      pathway3: {
        collection_1: '1. Recognizing Contributions',
        collection_2: '2. Extra Expo',
        collection_3: '3. Acting on Student Feedback',
      },
      pathway4: {
        collection_1: '1. Underground Spirit Week',
        collection_2: '2. Kind Notes and Shout-Outs',
        collection_3: '3. Metaphoric Toolbox',
      },
    },
  },
}
